import { combineReducers } from 'redux'
import profile from './profile.reducer'
import mail from './mail.reducer'

export default combineReducers({
  profile,
  mail
})
